import { Spin } from "antd";
import { useLocation } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { useAtomValue } from "jotai";
import { isWorkLeftPanelOpenAtom } from "@/atom/drawBoard";
import styles from "./index.module.scss";
import cls from "classnames";

function Loading() {
  const location = useLocation();
  const isCourse = location.pathname.toLowerCase() === "/course";
  const isWorkLeftPanelOpen = useAtomValue(isWorkLeftPanelOpenAtom);
  return (
    <div
      className={cls({
        [styles.container]: true,
        [styles.leftOpen]: isWorkLeftPanelOpen && !isCourse,
      })}
    >
      <Spin indicator={<LoadingOutlined spin style={{ fontSize: 20 }} />} />
    </div>
  );
}

export default Loading;
